import { useEffect } from "react";
import Header from "../../../components/Header/Header";
import RegistForm from "./../../../features/Error/unavailable/components/RegistForm";
import SuccessMsg from "./../../../features/Error/unavailable/components/Modal/SuccessMsg";
import useRegisterTrouble from "#features/Error/unavailable/hooks/useRegisterTrouble";
import { useLocation, useNavigate } from "react-router-dom";

const RegistUnavailblePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      navigate("/service-unavailable");
    };

    window.history.pushState(null, "", location.pathname + location.search);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.search, navigate]);

  const goBack = () => {
    navigate("/service-unavailable");
  }

  const {
    categoryKeys,
    activeTab,
    handleTabClick,
    formData,
    handleEmail,
    handleOnsubmit,
    handleChange,
    emailForm,
    showError,
    loading,
    modalIsOpen,
    closeModal,
  } = useRegisterTrouble();
  return (
    <>
      <section className="p-hasHeader">
        <Header title="고객지원 문의사항 접수" goBack={goBack} />
        <h2 className="pt-10 mb-8 text-3xl font-semibold">
          장애 발생 <br />
          문의사항 접수
        </h2>

        {/* 등록 FORM */}
        <RegistForm
          categoryKeys={categoryKeys}
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          formData={formData}
          handleEmail={handleEmail}
          handleOnsubmit={handleOnsubmit}
          handleChange={handleChange}
          emailForm={emailForm}
          showError={showError}
          loading={loading}
        />

        {/* 등록완료 모달 */}
        <SuccessMsg isOpen={modalIsOpen} onRequestClose={closeModal} />
      </section>
    </>
  );
};

export default RegistUnavailblePage;
